module.exports = __webpack_public_path__ + "static/media/Orkos_Siopis_2.7dc8bcb3.jpg";